import { Modal, Select, Flex, ButtonSize } from "@abel-technologies-as/components";
import { ModalHeader, GenericModalFooter } from "@/shared/components";
import { ModalProps } from "@/shared/types";
import { DeleteSquare } from "@/shared/icons";
import { ModalBody, SelectContainer } from "./style";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export const DeleteDhcModal = ({ open, setOpen }: ModalProps) => {
	const { t } = useTranslation("dhc");
	const [deleteOption, setDeleteOption] = useState<string>("");

	const onClose = () => {
		setOpen(false);
		setDeleteOption("");
	};

	const handleDelete = () => {
		onClose();
	};

	return (
		<Modal
			modalFooter={
				<GenericModalFooter
					onCancel={onClose}
					onConfirm={handleDelete}
					confirmLabel={t("delete")}
					variant="danger"
					size={ButtonSize.SMALL}
					disabled={!deleteOption}
				/>
			}
			onClose={onClose}
			isOpen={open}
			height="unset"
			modalHeader={
				<Flex width="450px">
					<ModalHeader
						title={t("delete_dhc")}
						icon={<DeleteSquare width="20" height="17" />}
						subTitle={t("delete_dhc_subtitle")}
					/>
				</Flex>
			}>
			<ModalBody>
				<SelectContainer>
					<Select
						showSearchBar={false}
						label={t("select_an_option")}
						title={t("select")}
						value={deleteOption}
						items={[t("delete_dhc_keep_clients"), t("delete_dhc_and_clients")]}
						onChange={(value) => setDeleteOption(value as string)}></Select>
				</SelectContainer>
			</ModalBody>
		</Modal>
	);
};
